import {FileAspectOrientationValue} from '../constants';
import {FileAspectOrientationValueLabel} from '../locales';

export const getOrientationLabel = (orientation: FileAspectOrientationValue) =>
	FileAspectOrientationValueLabel[orientation];

export default getOrientationLabel;
